import { useLocation } from "react-router-dom";

export const useS2Contract = () => {
  const { pathname } = useLocation();
  const isS2Contract = pathname.includes("contract-s2") || pathname.includes("billing-s2");
  return { isS2Contract };
};
